import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetCustomersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/get-customers-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchCustomerListContext } from '../../customer.context';
import { CustomerListFilterSearchFormStep1Controller } from '../customer-list-filter-search-form-step-1/customer-list-filter-search-form-step-1.controller';

export interface CustomerListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetCustomersPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetCustomersPaginatedModel>;
  onCancel: () => void;
}

export const CustomerListFilterSearchFormController = (
  props: CustomerListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchCustomerListContext();

  return (
    <HeadlessFormProvider<GetCustomersPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <CustomerListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
